// extracted by mini-css-extract-plugin
module.exports = {"comp":"C_comp__ymiLI"};